angular.module('capability-ng-anonymous-landing', [
  'ngSanitize',
  'ngAria',
  'ngMessages',
  'ngAnimate',
  'ct.ui.router.extras.core',
  'ct.ui.router.extras.dsr',
  'ct.ui.router.extras.sticky',
  'vendor'
]);



// WEBPACK FOOTER //
// ./app/lib/anonymous_landing/core.ts